import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  empty,
  get_data_value,
  intval,
  isEmpty,
  jQuery,
  showToast,
  timeConverter,
} from "utils/GlobalFunctions";
import { APP_NAME } from "config/CONSTANTS";

function UserCancelMembershipModal(props) {
  const {
    isVisible,
    setVisibleModal,
    pageData,
    submitCancelReason,
    modalClass,
    modalTitle,
  } = props;

  const defaultModalData = {
    reason: ""
  };
  useEffect(() => {
    if (isVisible !== undefined) {
      setShow(isVisible);
      setModalData(defaultModalData)

      setTimeout(function(){
        jQuery("#reason").focus()
      }, 500)
    }
  }, [isVisible]);
  const [show, setShow] = useState(false);

  const [modalData, setModalData] = useState(defaultModalData);
  const [errorField, setErrorField] = useState([]);

  const validateFields = () => {
    var errorList = Array();
    errorList = isEmpty(modalData, "reason", errorList);
    setErrorField([...errorList]);
    return errorList.length > 0 ? false : true;
  };

  const onChangeFormField = (e, field_name) => {
    if (errorField.includes(field_name)) {
      let errors = errorField.filter((x) => x != field_name);
      setErrorField([...errors]);
    }
    let updateData = {}
    updateData[field_name] = e.target.value;
    setModalData({ ...modalData, ...updateData });
  };
  const handleClose = () => {
    setShow(false);
    setVisibleModal(false);
  };

  const onClickSubmitModal = () => {
    let is_valid = validateFields();
    if (is_valid) {
      let reason_string = modalData['reason']
      if (reason_string.length < 10) {
        showToast("Please tell us the reason for cancellation (with at least 5 words)", "error")
        return false;
      }
      submitCancelReason({ ...modalData });
    }
  };
  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
        dialogClassName={modalClass}
      >
        <Modal.Header closeButton>
          <Modal.Title>{modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="block text-center">
            <div className="modal-box">
              <div id="dialog">
                <div className="text-normal text-left">
                  <div className="text-left">
                    <div className="form-group">
                      <label htmlFor="reason">In a few words, please tell us the reason for cancelling:</label>
                      <input
                        type="text"
                        autoComplete="off"
                        placeholder=" "
                        name="reason"
                        id="reason"
                        className={`form-control reason ${errorField.includes("reason")
                          ? "is-invalid"
                          : ""
                          }`}
                        value={modalData['reason']}
                        onChange={(e) => {
                          onChangeFormField(e, "reason");
                        }}
                      />
                    </div>
                    <div className="alert alert-warning mt-0 mb-0" role="alert">
                      <div className="note mb-0 text-left">
                        <p>Please use at least 5 words to help us improve our services, thank you!</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-md btn-close-dlg btn-light margin-right-10"
            data-dismiss="modal"
            onClick={handleClose}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-md btn-submit-modal-data btn-primary"
            onClick={onClickSubmitModal}
          >
            End Membership
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default UserCancelMembershipModal;
